import {
  LicenseStatusEmailNotificationOutcome
} from '@strenforcement/domain/licenseStatusEmail';

export function getLicenseStatusEmailNotificationToast(notification) {
  const name = notification?.ruleName || 'Approval notification';
  switch (notification?.outcome) {
    case LicenseStatusEmailNotificationOutcome.queued:
      return { message: `${name} queued for the applicant.`, options: { type: 'primary' } };
    case LicenseStatusEmailNotificationOutcome.skippedByStaff:
      return { message: `${name} was skipped.`, options: { type: 'primary' } };
    case LicenseStatusEmailNotificationOutcome.missingRecipient:
      return {
        message: `${name} was not queued because the applicant has no email address.`,
        options: { type: 'warning' }
      };
    case LicenseStatusEmailNotificationOutcome.alreadyQueued:
      return { message: `${name} is already queued.`, options: { type: 'primary' } };
    case LicenseStatusEmailNotificationOutcome.alreadyEvaluated:
      return { message: `${name} was already handled for this license.`, options: { type: 'primary' } };
    default:
      return null;
  }
}

export function showLicenseStatusEmailNotificationToasts(component, notifications = []) {
  notifications.forEach(notification => {
    const toast = getLicenseStatusEmailNotificationToast(notification);
    if (toast) component.$showToast(toast.message, toast.options);
  });
}
